/* eslint-disable @typescript-eslint/no-explicit-any*/
import { API_URL } from '@portal/config/env';
import { getInstance } from '@portal/repositories/securitySdkConfig';
import { FaqTopic, FaqTopicQuestion } from '~/models/module';

const FaqApi = {
  getLoggedFaq: async () => {
    const instance = getInstance();
    const { data } = await instance.get(`${API_URL}/faq/logged`);

    return data;
  },
  getFaqTopicReport: async (params: any) => {
    const instance = await getInstance();
    const { data } = await instance.get(`${API_URL}/faq`, { params });

    return data;
  },
  getFaqTopicDetails: async (id: any) => {
    const instance = await getInstance();
    const { data } = await instance.get(`${API_URL}/faq/${id}/topic`);

    return data;
  },
  removeFaqTopic: async (id: string) => {
    const instance = await getInstance();
    const { data } = await instance.delete(`/faq/${id}/topic`);

    return data;
  },
  editFaqTopic: async (id: string, payload: FaqTopic) => {
    const instance = await getInstance();
    const { data } = await instance.put(`/faq/${id}/topic`, payload);

    return data;
  },
  editFaqTopicOrderUp: async (id: string) => {
    const instance = await getInstance();
    const { data } = await instance.post(`/faq/${id}/topic-up`);

    return data;
  },
  editFaqTopicOrderDown: async (id: string) => {
    const instance = await getInstance();
    const { data } = await instance.post(`/faq/${id}/topic-down`);

    return data;
  },
  addFaqTopic: async (payload: FaqTopic) => {
    const instance = await getInstance();
    const { data } = await instance.post('/faq/topic', payload);

    return data;
  },

  getFaqTopicQuestionReport: async (topicId: string, params: any) => {
    const instance = await getInstance();
    const { data } = await instance.get(
      `${API_URL}/faq/${topicId}/topic-questions`,
      { params }
    );

    return data;
  },
  getFaqTopicQuestionDetails: async (id: string) => {
    const instance = await getInstance();
    const { data } = await instance.get(`${API_URL}/faq/${id}/question`);

    return data;
  },
  removeFaqTopicQuestion: async (id: string) => {
    const instance = await getInstance();
    const { data } = await instance.delete(`/faq/${id}/question`);

    return data;
  },
  editFaqTopicQuestion: async (id: string, payload: FaqTopicQuestion) => {
    const instance = await getInstance();
    const { data } = await instance.put(`/faq/${id}/question`, payload);

    return data;
  },
  editFaqTopicQuestionOrderUp: async (id: string) => {
    const instance = await getInstance();
    const { data } = await instance.post(`/faq/${id}/question-up`);

    return data;
  },
  editFaqTopicQuestionOrderDown: async (id: string) => {
    const instance = await getInstance();
    const { data } = await instance.post(`/faq/${id}/question-down`);

    return data;
  },
  addFaqTopicQuestion: async (topicId: string, payload: FaqTopicQuestion) => {
    const instance = await getInstance();
    const { data } = await instance.post(`/faq/${topicId}/question`, payload);

    return data;
  },
};

export default FaqApi;
